import { IPanel, LinkActionSchema } from "smarthub-common";

export const chatPanel: IPanel = {
  $id: "panel.chat",
  $schema: "https://ics.ai/smarthub/panel",
  group: "panels.intranet",
  description: "Chat transcript and controls",
  title: "Chat",
  shortTitle: "chat",
  icon: {
    name: "Chat",
  },
  order: 1,
  initialFocus: "chat-controls",
  navigation: "none",
  menu: {
    $id: "component.chat-menu",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-menu",
    title: "Chat menu",
    description: "Choose display settings",
    props: {
      showLauncher: false,
    },
  },
  pages: {
    $id: "component.chat-pages",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-pages",
    title: "Chat pages",
    description: "Chat pages",
    props: {
      config: {
        pages: [],
      },
    },
  },
  launcher: {
    $id: "component.chat-launcher",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-launcher",
    title: "Chat launcher",
    description: "Chat launcher",
    props: {
      enabled: false,
      config: {
        title: {
          en: "SmartChat Launcher",
        },
        subtitle: {
          en: "Click to start a chat, or quick link",
        },
        sections: [],
      },
    },
  },
  splash: {
    $id: "component.chat-splash",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat splash",
    description: "Chat splash",
    template: "component.chat-splash",
    props: {
      enabled: true,
      mode: "implicit",
      cacheLocation: "session",
      version: "1.0",
      sessionKey: "customer.ai-flex-chat-tnc-acceptance",
      config: {
        html: {
          en: `<img style="width:100px;align-self:center;margin:20px 0px;" alt="Impy" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAydpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAxIDc5LjE0NjI4OTk3NzcsIDIwMjMvMDYvMjUtMjM6NTc6MTQgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyNS4wIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxODYwMkFGNzZEOTYxMUVFOTI1OEQ1QjE4NTcwNjI5QyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxODYwMkFGODZEOTYxMUVFOTI1OEQ1QjE4NTcwNjI5QyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE4NjAyQUY1NkQ5NjExRUU5MjU4RDVCMTg1NzA2MjlDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjE4NjAyQUY2NkQ5NjExRUU5MjU4RDVCMTg1NzA2MjlDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+RlVD2QAADcpJREFUeNrsXV9MZFcZvxC6KS3EYZVkSbplaIrJslEG09oYsw7Ep/UFNrUJiYk74It9KWx88UUBffHFAPpgX4TBxEiiZuGl+9Qw48aY2kYGzdLE3ZTZpRESVucmULu2TdbzO/d8w5nLvXP/nXvvmeqX3J1hYWbunN/5vu/3fec732l7/Pix8X/RR9q0v8PJlRz7F1eWXcPsyojnWY9XVthlimtH/Fw11qcrun5VKEebhgCMsn9x5cXjGck8dc7IZc83fZvS7qHbr0wBzib+TCeA9AFkcmWC/TvOrgmhAVyyvV1Grv88G/zPGvlLF4zM0+f4z0Gkcv9fRvXoxNhhj5XqPzlQ5r8/kv+kyq4Ndq2lDU66gEyuwOTMsKtAIGDmjw5dMMZf6OePACQOAUAb7zwwyrsH/NEGzjK7igwc838DEMskXRdAcCnkn+cgTLzwbOK3A23ZePuBsfnOfTs4RXYtMGCqn05ALOe8SH4Bs3/m6mUOBjRDB4HmLN+6YxTL92SzlhgwyQAyuZIRQBQIiLmXRzgQugrAWL61ayy9cUcGZoFdS3GasvgBmVyZZf/OwT20AhA+gIGW3GCgbLQWIJbDXiXzNP/NEWaehrQxTWGAufGrt7gpEwJAplRrSzyATK4UhInKgKKuvnolMFXVVUCZp16/zX2N0BaAUtIXkMmVVfIV0Iq5l3NK3navusAfB7JzOmoLTNiSXoBYjnsLKQ6YpZvf+zqPI1RIzSwZf9ke48+/+pU948kns1poCwABMMK3IG6ZUgFIuyJ/wcGAadr7+SvKwIAcHW3Wnx8crmljvkBOtn54lYLXAhuHbTExI0l7RDBgk7YBBt2gasdtmqcm+sH+kvHoUVUbUDABt38yTj4yxydmRFDaI4IBzcgAjNXvXomFRR2fnKaXPvnENP76t2taOXp8Z0xEVaC0qQIjLnlz6+wt9mRGjS9+4abR0ZGpg/bw4aZRqzUSnp6eUeZz+vnfx+17bM4es2gsKC0O59QlBx43GG6AQABG7+cmuAmrmd7ME4AAmL6+6/wxLlDGfnSLZ5g5KOvTI0kAsp0UGJDy7R5uqlQKwPn84CIHNGZQArGv4CzLijM4m1r89kuJ2Og4Bg1aBV8EOq0abPIpEvuajcepWxF4gT4wqTQITExcAlP3xz8NNBAHVaAgFhNjtCiWHBQCcpo6TxQMzGTTLMf6GcTcmmkKfrf77lQ9Y+CXEktWZNUv8/KrITBVGXxAUnmpv9+9wWfve3vziQC///6y4+8ODov8PvBoZ3F+gkeR3c6KMfSUDh/agRHJIfqevTqUGL8/OUl2eRtB58cfm8YTT1gTGc+PHm40BKJEs4MIJjGSktWjkwleO+CRum/zkRbZg4lCRBrXGreT7L+/xLVEJxm6tGr0XSgEfh0AGfvxLTwFuiNu8YkflsXVbPYblxMFgztz9sV1SSTKcU8YgXWRTNdsOB8i6qOslb5cKgMgR+Npy7MXZyPdC0yXIENzwvIEdupz9EZpSXdXzvjSyFbqmoL7uPjMTGQqDEsjj61/QIR2QNXSKM2xD8ZLL24bzw3Mp6ItNClUfLa0jF1w05L2ZtqBogRd7DdWC2E2kpSLz8wqA8OvlrS7aQfiDZULTWqA+Uyik+C5gTnlWmnTkowfDbluvfCyoZvEkdfyiuBVC8CQSqEKzQGxECvYXqSNUAo9KUGuCxG6apEm+4yXhkxQyB8lDYEv4nSpWH4dHFxM1Gx1damn/AglBFnKijyha+pknNus/KCvN0aWFGvetVqZP/c74PiiYC+Y8Z2dWSOTyfOf/dhr/B0iZiT74jaPA8yHdHfFE4OhuFwUd8NFVM6mTixzVQN6ez97pembQY3395eVp63JJPX05D2XXXEPSK1EXc9ARgApfkwmTAiaLHFTbCxk9Xzn11Y6ZX16gFInMiBwMKtIILoFg0i2YRCSqvwAIJipAMjJoeM+oCl+lnDdwIC2pSXXfvomaQnyWxUAIpusPKmSk+CLk4PD7IVtRWa0q2u4YTZhkB49um85xVqJz+CwmmSlxZf4hc/A5/b2jnNw8DMAQ5wAQKCxmDB+BYFm2pWQ+aE+AmSUzJasIXtwMo9/M+UIBgYHqk2DEVQAClLqx8c73O9EMXeU6CNwZKoKUODTnIofZEB1SFxi3X3k+7wQcINpyLVTkyXS7AgEt35w1XEgw6SdvXh+TRAC+7pDUHDsmtNKAj/C/InJAOmRAcE0u6myQDqMeQIwBwdrkbQHDrm3d4IztyRiFtwrzCUmGLLTEfzIALNOVfIhHIXhFLcNwIQgd4QrCjj4e/k1ACjDgOnuHlYWWEKzUXMsazZ8WRjBDmMBCDCoAzJMAYsuEbkMDoqs/3FQDGXW7ADR+3eyi4gJxE5O6vRUFFkcH1txltMEAUEIC7SkBABkgwDhd6LjxhoMHtgQLp7KYFoTNZ1hMcFqaLpsp85R2JqkBP1y6mRUF+1wc/7EkhA35K/UeOVh2kxJRRwjKUG2IZelKyCg3KgwREkpnsNkwLTAnGEDD2x3kllgYnYAQnFQmbFyWQo2mcQl3HmKYA+aAlOFiy+pXpyxonikWtiliqX5yXGp1k6EG6XdwxwlF3PWf/ZpqR1ujhq/6+i4Uc9FWevejSwNTEiFn5BzXnFT6Q6dtcOLVUFrKLUCQCiTILM0ei+wpWZMySmeAQujPFpSAae2gCDYCkxv71Z48pOCQ2I/ZNbsYDoBAzqcJlnQFpAgiUKix5jJfgNASrnoJh26mqsgth0O3r6Q1Ow90taClgPEzxYEAAG2I+8zBMMKkkmmtAotiOmQmAQg3HOWdg9SSyza5cMPq01NE5J4pBGgwe/tLURKq4AUEKVNO2vcnmSDriCpDbcYAFWMAAMD+ee3R+prNar8Ft4P+0GSXBkV/SGrDZG6+cFHhs4CE0XF19jJBDDiCgCJTgMYlYB7SAMgJbFrVFswkKagrWVJ7KoioR1UmASqN4hCpHE3GzSEQ2S1HUpdZAYEM0U5I1QSxlG45kcwCd5iWqkq8newTDsyIGWdAEGtFsUKBEaU6hKVvg2JThXlRyTldw8bTBbR3gr9UocCayy/QojW8qRhBM2gILC7O1d/bye/cXKywxme11oJ/Avo9SU2WaIW0qGXsIyBZ5FDWgKn/WXGqDBQsOFBZyRVpjgFjUECVBR4uCUpSYOjpP8HXvutZZnWp9vshXK1zFPnMrVffksLQAAAMaqgThxJRdVbCajEiNbSZQm7GRRAABDDank+Zt/0WUJ5oy5sC4OJQcB25SBkAFolR/Aq74eoN1YsAQLlwoI2FbDFH3UfbmdZvGJrs7G7c6oCv+HXVNHWt7iKo53AwWolVi2hkSjCCAoKumkTNvRENlncj1CXNF38iJ/gz94/q1VELpLDz40my0qhVOg0AR18iN+FpFYEA7VYooHmRmMuq1F4l8m1P9xL/Yb9xBy67WUPaa42mwHC0SqW76Z+w4gJvARMStd1jabROdMM0QrQtPc+aQTEMlsbdL5GmoL1by9GRWvmrSboJy/kTLTrtAt32XrRndR9iJd2tKpIFmjZGxCrl3kVHLnJOU6pxyhJF8epA+Mekaai01qUWycHTqgXfr+t5ZdqxX0g9YE9HVPHNt3OgKxPF3XWEqyBt7h2lNxOVWjWDUhbLWlVZoVGy0JcO7O5A2JpSQkaIh3NkJg027CvYz2VH2YlnaRQCQ6IpCXSsQyJSWdnv/FpEWQ/5n+3bcUdTbTDGxDLzi0BjKlf3NZGQ1pNpLFb8OoH76dNLLSkikAxyWCxFc2SM6uq0JJGyc9JPN6AWIhOEdJJJh5bNdYggf+VTJWv5iz+GilbpmsBpgvbeJPyJ6gibFWhsaqzKp8Fif57v69Pzxuifkuib6loyPFJRXswcEKCxKqKfl8b9IQdtFir0oFYSaRInNaqdTr2yEkwNtIZIoH6SAUDxPInAMVcYrw6ifgEVSN28ZOaT41RvX678ZSdgBL8DCorqMEHmdKHxyZYEbQzrqBN8VMAw5q4IU4CDXcoWMKg2Nv6pV3B6AOMsbC7CsKf0mYDJU6fwjd02nxJ0C1vcTpwBzBCs45o5xhKoMCn4MbiosT2Wiv5wMm02ZTtZLZIFFDV0avIc6A3URZlRDjuJ47OENAK6qULcFCwlpaARUnUNtQxeXZRezix1RECoIyi7y9OiY6jb7zcajBsCWdUgTWQTLSSc3DVA3IKDAJIvuANQACMyjOrsNaOLQEIDsG+wvapCiNIG8Esi0U7U0TgRVXvH+cB9+Cp2NiRBRjocqqyUzYCQ2yeAThJnSCNJOHSG3dkEzUV1V8kB8ipCYOm8FodbHXAaQuq9p9AQ6Ap8g6rOAQZbpgnKam6INJIyiVeQBq1BcCMqgaGQIGWqC56gFnC8rVUU1ASWhFb3iYZQE6BKQhgsgQMmtJHdfzU4lxVqh4UFjVp0raMktCK2KPRZAFxAQb0uJAfNK5/7fnUmqhh8NfKdzkYUhyVGBDpAtJoypA5rE9txDATL/Yb40xr4u7/CFOEgmf4CNuiG1jTsmqHrT8gp8BkBSg4JaC+kA52lsue543V8pcucO0Jq0G0xWKHPaKFiEOtGfIwm4bVYdpMayj0AOQsONCccfF4xlNDczJPW3GNUxc884P/1O0/QHBZcq4Kk1ROGwS9AXEGKCcuKlccDWqdRBC3I+KHio79XVoDEG+w3CLCii6zPigg/xVgAGfgs7IqOV3qAAAAAElFTkSuQmCC"/>
          <h1 style="font-size:25px;font-weight:bold;text-align:left;">ASK IMPY</h1>
          <h2 style="font-size:20px;font-weight:bold;text-align:left;">Welcome</h2>
          <p style="text-align:left;">Hello, I'm Impy, your digital assistant. How can I help you today?</p>
          <p style="text-align:left;">You can ask me questions relating to council services. I find it easiest to understand if your question is phrased clearly, in four or more words.</p>          
          <p style="text-align:left;">If my answer isn't quite what you were looking for, please try rephrasing your question. </p>
          <p style="text-align:left;">I am still learning, so please let me know how I've done when prompted. </p>
          <p style="text-align:left;">Our Customer Services privacy notice is available <a aria-label="Privacy Policy - link opens in a new tab" title="Privacy Policy - link opens in a new tab"  href="https://www.lincolnshire.gov.uk/directory-record/62064/customer-services-privacy-notice" target="_blank"><u>here</u></a></p>
          <p style="text-align:left;">To start a chat, please choose continue.</p>
          `,
        },
        container: {
          margin: "0px",
          padding: "20px",
          backgroundColor: "#fff",
          textColor: "#000",
          fontSize: "16px",
          textAlign: "center",
        },
        buttons: {
          primaryButtonBackgroundColor: "#00589f",
          primaryButtonHoverBackgroundColor: "#333",
          primaryButtonTextColor: "white",
          primaryButtonHoverTextColor: "white",
          primaryButtonPadding: "20px",
          primaryButtonFontSize: "18px",
          secondaryButtonBackgroundColor: "#00589f",
          secondaryButtonHoverBackgroundColor: "white",
          secondaryButtonTextColor: "white",
          secondaryButtonHoverTextColor: "black",
          secondaryButtonPadding: "20px",
          secondaryButtonFontSize: "18px",
        },
      },
    },
  },
  header: {
    $id: "component.chat-header",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat header",
    description: "Chat header",
    template: "component.chat-header",
  },
  footer: {
    $id: "component.chat-footer",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat footer",
    description: "Chat footer",
    template: "component.chat-footer",
    props: {
      actions: [
        {
          name: {
            en: "privacy",
          },
          title: "",
          shortTitle: {
            en: "Privacy Statement",
          },
          description: "",
          action: {
            $id: "",
            $schema: LinkActionSchema,
            uri: "https://www.lincolnshire.gov.uk/privacy",
            target: "_self",
          },
        },
      ],
    },
  },
  templates: [
    {
      $id: "template.chat",
      $schema: "https://ics.ai/smarthub/template",
      description: "Felix chat transcript and controls",
      title: "Felix chat",
      shortTitle: "Chat",
      group: "templates.intranet",
      tabs: [
        {
          $id: "layout.chat",
          $schema: "https://ics.ai/smarthub/tab",
          description: "Felix chat transcript and controls.",
          group: "tabs.intranet",
          title: "Chat",
          shortTitle: "Chat",
          icon: {
            name: "Chat",
          },
          body: {
            grid: {
              tokens: {
                padding: "none",
              },
              rows: [
                {
                  responsive: {
                    sm: { scroll: true, stretch: true },
                  },
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.main",
                        },
                      ],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.controls",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            zones: [
              {
                id: "zone.main",
                components: [
                  {
                    $id: "component.chat-transcript",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat conversation",
                    template: "component.chat-transcript",
                  },
                ],
              },
              {
                id: "zone.controls",
                components: [
                  {
                    $id: "component.chat-controls",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat controls",
                    template: "component.chat-controls",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
